import { W as WuiToggle$1, d as defineCustomElement$1 } from './p-DmYQIev2.js';

const WuiToggle = WuiToggle$1;
const defineCustomElement = defineCustomElement$1;

export { WuiToggle, defineCustomElement };
